
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"14","height":"14"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"translate(-1 -1)","fill":"none","stroke":"#a2a2a2","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2"}},[_c('circle',{attrs:{"data-name":"Ellipse 389","cx":"6","cy":"6","r":"6","transform":"translate(2 2)"}}),_c('path',{attrs:{"data-name":"Path 32030","d":"M8 4.4V8l2.4 1.2"}})])])
          )
        }
      }
    